<template>
  <div :data-testid="getTestId('admin-users-page')">
    <UserCrudTable :data-testid="getTestId('admin-users-table')" />
  </div>
</template>

<script>
import { getTestId } from '@/utils/testUtils';

export default {
  name: 'UsersPage',
  components: {
    UserCrudTable: () => import('../../components/table/UserCrudTable')
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};
</script>

<style>

</style>
